module.exports = __webpack_public_path__ + "media/images/hindu-matrimony-banner-ab512c0a1d47f0bf5791b850db2b543b.jpg";